/**
 * @enum {Object{String}} DOMAIN
 * @description dictionary that contains the analytics domain type.
 */
export enum DOMAIN {
  PUBLIC_GRID = 'public_grid',
}

/**
 * @enum {Object{String}} VERB
 * @description dictionary that contains the analytics verbs type.
 */
export enum VERB {
  CLICKED = 'clicked',
  ERRORED = 'errored',
  /**
   * The tracker has no `completed` verb, and `enrolled` would be a lie: a
   * resident who skips also finishes the flow. We report what actually
   * happened — we received Public Grid's completion signal — and let the
   * `enrolled` detail carry the outcome.
   */
  RECEIVED = 'received',
  VIEWED = 'viewed',
}

/**
 * @enum {Object{String}} OBJECT
 * @description dictionary contains the analytics object type.
 *
 * NOTE: the embed `url` is a bearer credential and must never appear in an
 * analytics payload, a breadcrumb, or an error report. Report the mint as an
 * event with no URL in it. The same holds for the `accountNumber` on a
 * completion message — it is a live account identifier.
 */
export enum OBJECT {
  ELIGIBILITY = 'eligibility',
  EMBED = 'embed',
  EMBED_FALLBACK_BUTTON = 'embedFallbackButton',
  EMBED_MINTED = 'embedMinted',
  FLOW_COMPLETION = 'flowCompletion',
}

/**
 * @enum {Object{String}} PAGE
 * @description dictionary contains the analytics page name.
 */
export enum PAGE {
  EMBED = 'embed',
}

/**
 * Why an eligibility check ended without an answer. All three fail closed to
 * ineligible, so they are indistinguishable in the UI and only separable here.
 */
export enum ELIGIBILITY_FAILURE {
  /** Public Grid answered with an `error` in the payload. */
  PARTNER_ERROR = 'partner_error',
  /** The request itself failed — network, 5xx, GraphQL transport. */
  TRANSPORT_ERROR = 'transport_error',
  /** No answer inside {@link ELIGIBILITY_TIMEOUT_MS}; we stopped waiting. */
  TIMEOUT = 'timeout',
}
